"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectUtilities = void 0;
const Rectangle_1 = require("../../graphics2d/Rectangle");
const Rectangle2D_1 = require("../../graphics2d/Rectangle2D");
class RectUtilities {
    static makeRectangleFromRect(x1, y1, x2, y2) {
        return new Rectangle_1.Rectangle(x1, y1, x2 - x1, y2 - y1);
    }
    static makeRectangle2DFromRect(x1, y1, x2, y2) {
        return new Rectangle2D_1.Rectangle2D(x1, y1, x2 - x1, y2 - y1);
    }
    /**
     * Copies a Rectangle
     * @param rect {@link Rectangle2D}
     * @return {@link Rectangle2D}
     */
    static copyRect(rect) {
        return new Rectangle2D_1.Rectangle2D(rect.getX(), rect.getY(), (rect.getWidth() + 0.5), (rect.getHeight() + 0.5));
    }
    /**
     * copies and rounds the points.  x,y round down &amp; width,height round up
     * @param rect {@link Rectangle2D}
     * @return {@link Rectangle2D}
     */
    static roundRect(rect) {
        let offsetX = rect.getX() - (rect.getX());
        let offsetY = rect.getY() - (rect.getY());
        return new Rectangle2D_1.Rectangle2D(rect.getX(), rect.getY(), (Math.round(rect.getWidth() + offsetX + 0.5)), Math.round(rect.getHeight() + offsetY + 0.5));
    }
    static grow(rect, size) {
        rect.setRect(rect.getX() - size, rect.getY() - size, rect.getWidth() + (size * 2), rect.getHeight() + (size * 2));
        //return new Rectangle2D(rect.left - size, rect.top - size, rect.right + size, rect.bottom + size);
    }
    static shift(rect, x, y) {
        rect.setRect(rect.getX() + x, rect.getY() + y, rect.getWidth(), rect.getHeight());
    }
    static shiftBR(rect, x, y) {
        rect.setRect(rect.getX(), rect.getY(), rect.getWidth() + x, rect.getHeight() + y);
    }
    static toRectangle(...args) {
        switch (args.length) {
            case 1: {
                const [b] = args;
                if (b == null) {
                    return null;
                } /*from w ww . j a  va 2s . c o  m*/
                if (b instanceof Rectangle_1.Rectangle) {
                    return b;
                }
                else {
                    return new Rectangle_1.Rectangle(b.getX(), b.getY(), b.getWidth(), b.getHeight());
                }
            }
            case 4: {
                const [x, y, w, h] = args;
                return new Rectangle_1.Rectangle(x, y, w, h);
            }
            default: {
                throw Error(`Invalid number of arguments`);
            }
        }
    }
    static toRectangle2D(...args) {
        switch (args.length) {
            case 1: {
                const [b] = args;
                if (b == null) {
                    return null;
                } /*from w ww . j a  va 2s . c o  m*/
                else {
                    return new Rectangle2D_1.Rectangle2D(b.getX(), b.getY(), b.getWidth(), b.getHeight());
                }
            }
            case 4: {
                const [x, y, w, h] = args;
                return new Rectangle2D_1.Rectangle2D(x, y, w, h);
            }
            default: {
                throw Error(`Invalid number of arguments`);
            }
        }
    }
}
exports.RectUtilities = RectUtilities;
//# sourceMappingURL=RectUtilities.js.map